if (!customElements.get('popup-module')) {
    customElements.define(
        'popup-module',
        class PopupModule extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                if(this.dataset.insertAfterBody && this.dataset.insertAfterBody !== 'done') {
                    const main = this.closest('#MainContent');
                  
                    if(main) {
                      this.dataset.insertAfterBody = 'done';
                      this.connectedCallback();
                      main.after(this.closest('.shopify-section'));
                      return;
                    }
                }

                this.timer = this.dataset.cookiesLife;
                this.edgeLimit = 70;
                this.animationDuration = parseInt(window.getComputedStyle(document.body).getPropertyValue('--popups-transition-duration'));
                this.closeButton = this.querySelectorAll('[data-popup-close-button], .modal-overlay');
                this.onEscapeKeyHandler = this.onEscapeKey.bind(this);
                
                if(document.body.classList.contains('popup-blocked-all') && !this.dataset.blockAll) {
                    window.addEventListener('popupsUnblocked', () => this.init(), { once: true });
                } else {
                    this.init();
                }
            }

            init() {
                this.dataset.showOnMobile === 'false' ? themeBase.viewportFunction(true, this.onLoad) : this.onLoad();
            }

            onEscapeKey(event) {
                if (event.code.toUpperCase() === 'ESCAPE') {
                    document.removeEventListener('keyup', this.onEscapeKeyHandler);
                    this.hide();
                }
            }

            show() {
                if(this.checkCookies() || this.classList.contains('popup-module--open')) return;
                if(this.dataset.blockAll) document.body.classList.add('popup-blocked-all');
                if(this.dataset.scrollTop) window.scrollTo(0, 0);
                if(this.dataset.freeze) {
                    themeBase.freezeScroll({
                        additionalClass: 'popup-module-visible'
                    });
                }
                
                this.classList.add('popup-module--open');
                setTimeout(() => window.dispatchEvent(new Event('popupToogled')))

                if(this.dataset.bodyClassname) document.body.classList.add(this.dataset.bodyClassname);
                if(this.dataset.escapeKey) {
                    document.addEventListener('keyup', this.onEscapeKeyHandler);
                }
            }

            hide(event) {
                if(event) event.preventDefault();

                themeCookies.setWithTimer(this.timer, this.dataset.cookiesName, 'off');
                this.classList.add('popup-module--close');

                if(this.dataset.bodyClassname) document.body.classList.remove(this.dataset.bodyClassname);

                setTimeout(() => {
                    this.classList.remove('popup-module--open', 'popup-module--close');
                    
                    if(this.dataset.freeze && !document.querySelectorAll('.popup-module--open:not(.popup-module--close)[data-freeze]').length) {
                        themeBase.unfreezeScroll({
                            additionalClass: 'popup-module-visible'
                        });
                    }
                    if(this.dataset.blockAll) {
                        document.body.classList.remove('popup-blocked-all');
                        window.dispatchEvent(new Event('popupsUnblocked'));
                    }
                }, this.animationDuration);
                setTimeout(() => window.dispatchEvent(new Event('popupToogled')))
            }

            checkCookies() {
                return themeCookies.get(this.dataset.cookiesName) === 'off' && window.location.href.indexOf(this.dataset.urlCall) === -1;
            }

            onLoad() {
                if (this.checkCookies()) return;

                if(this.dataset.showTrigger === 'delay') {
                    setTimeout(() => this.show(), (this.dataset.delay || 0) * 1000);
                } else if(this.dataset.showTrigger === 'exit_intent') {
                    let enableHandler = false;
                    const mousemoveHandler = event => {
                        if(!enableHandler && (event.clientX > this.edgeLimit && event.clientX < window.innerWidth - this.edgeLimit && event.clientY > this.edgeLimit && event.clientY < window.innerHeight - this.edgeLimit)) {
                            enableHandler = true;
                        } else if(enableHandler && (event.clientX < this.edgeLimit || event.clientX > window.innerWidth - this.edgeLimit || event.clientY < this.edgeLimit || event.clientY > window.innerHeight - this.edgeLimit)) {
                            window.removeEventListener('mousemove', mousemoveHandler);
                            this.show();
                        }
                    };

                    window.addEventListener('mousemove', mousemoveHandler);
                } else if(this.dataset.showTrigger === 'copy_to_clipboard') {
                    window.addEventListener('copy', () => this.show());
                }

                this.closeButton.forEach(button => button.addEventListener('click', (e) => this.hide(e)));
            }
        }
    );
}